<template>
  <div id="app">
    <!-- 팝업 배너 -->
    <PopupBanner />
    
    <!-- 고정 헤더 영역 -->
    <div class="sticky-header" v-if="!isAdminPage">
      <TopBanner v-show="!isMobileMenuOpen" />
      <AppHeader 
        :showSearchIcon="showSearchIcon && !isMypagePage"
        :isSearchOpen="isSearchOpen"
        @open-search="toggleSearch"
        @menu-open="isMobileMenuOpen = true"
        @menu-close="isMobileMenuOpen = false"
      />
      
      <!-- SearchHeader - 마이페이지, 모바일 메뉴 열리면 숨김 -->
      <div 
        v-if="!isMypagePage"
        class="search-header-wrapper" 
        :class="{ hidden: !isSearchVisible || isMobileMenuOpen }"
      >
        <SearchHeader @search="handleSearch" />
      </div>
    </div>
    
    <!-- 검색창 열렸을 때 바깥 클릭 감지 -->
    <div v-if="isSearchOpen && !isMypagePage" class="search-overlay" @click="closeSearch"></div>
    
    <!-- Admin일 때는 탑배너만 -->
    <TopBanner v-if="isAdminPage" />
    
    <router-view />

    <!-- 푸터 - Admin 페이지에서는 숨김 -->
    <AppFooter v-if="!isAdminPage" />
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import TopBanner from '@/components/layout/TopBanner.vue'
import SearchHeader from '@/components/layout/SearchHeader.vue'
import PopupBanner from '@/components/PopupBanner.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    TopBanner,
    SearchHeader,
    PopupBanner
  },
  setup() {
    const route = useRoute()
    const scrollY = ref(0)
    const isSearchOpen = ref(false)
    const isMobileMenuOpen = ref(false)
    const isSearchHidden = ref(false)
    let ticking = false

    const isAdminPage = computed(() => route.path.startsWith('/admin'))
    const isMypagePage = computed(() => route.path.startsWith('/mypage'))

    const isSearchVisible = computed(() => {
      return !isSearchHidden.value || isSearchOpen.value
    })

    const showSearchIcon = computed(() => {
      return isSearchHidden.value
    })

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentY = window.scrollY
          
          if (currentY > 200 && !isSearchHidden.value) {
            isSearchHidden.value = true
          } 
          else if (currentY < 50 && isSearchHidden.value) {
            isSearchHidden.value = false
          }
          
          scrollY.value = currentY
          ticking = false
        })
        ticking = true
      }
    }

    const toggleSearch = () => {
      isSearchOpen.value = !isSearchOpen.value
    }

    const closeSearch = () => {
      isSearchOpen.value = false
    }

    const handleSearch = (searchData) => {
      console.log('검색:', searchData)
    }

    watch(() => route.path, () => {
      isSearchOpen.value = false
      isMobileMenuOpen.value = false
      isSearchHidden.value = false
    })

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true })
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      isAdminPage,
      isMypagePage,
      isSearchVisible,
      isSearchOpen,
      showSearchIcon,
      isMobileMenuOpen,
      toggleSearch,
      closeSearch,
      handleSearch
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
  color: #191f28;
  background-color: #f9fafb;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  font-family: inherit;
}

/* 고정 헤더 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
}

/* SearchHeader 래퍼 */
.search-header-wrapper {
  transition: opacity 0.25s ease, transform 0.25s ease, max-height 0.25s ease;
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

.search-header-wrapper.hidden {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
  overflow: hidden;
  pointer-events: none;
}

/* 검색창 바깥 클릭용 오버레이 */
.search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
}
</style>